import debounce from 'lodash.debounce'

export const validateField = (schema, values) => {
  return debounce((name, actionHandler = () => {}) => {
    return (
      schema
        .validateAt(name, values)
        .then(() => {
          actionHandler({ valid: true, errors: '' })
        })
        .catch(e => {
          actionHandler(e)
        })
    )
  }, 200)
}

export const validateValues = schema =>
  debounce((values, callback) => schema.isValid(values).then(callback), 400)
